export default __webpack_public_path__ + "static/media/banner-3.91b7dc68.png";